import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@aura/components/styles'
import Grid from '@aura/components/grid'
import { useTranslation } from 'react-i18next'
import { useAuraThemeSwitcher } from '@aura/components/themes'
import RegistrationContainer from '../registration-container'
import AppBar from '../app-bar'
import Footer from '../footer'
import styles from './styles'


const Component = ({
    classes
}) => {

    const { t: translate } = useTranslation()
    const { updateTheme } = useAuraThemeSwitcher()
    const title = translate('ssoError.title')
    const verbiage = translate('ssoError.verbiage')

    useEffect(() => {
        updateTheme({ palette: 'light' })
    }, [])

    return (
        <>
            <AppBar />
            <Grid container className={classes.gridContainerCenter}>
                <Grid className={classes.ssoErrorRoot} md={5} sm={8} xs={12}>
                    <RegistrationContainer {...{ title, verbiage }}>
                    </RegistrationContainer>
                </Grid>
            </Grid>
            <Grid container className={classes.gridContainerCenter}>
                <Grid md={5} sm={8} xs={12}>
                    <Footer />
                </Grid>
            </Grid>
        </>
    )
}

Component.displayName = 'OktaRegistrationWizard.SsoError'

Component.propTypes = {
    classes: PropTypes.shape({
        heading: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        registrationRoot: PropTypes.string.isRequired,
        root: PropTypes.string.isRequired,
        verbiage: PropTypes.string.isRequired
    })
}
export default withStyles(Component, styles)
